import { slice } from '../slices/teamShare';

const nameSpace = slice.name;

/**
 * @param state
 * return {Boolean}
 */
export const isLoading = (state) => state[nameSpace].isLoading;
/**
 * @param state
 * return {Number}
 */
export const totalCount = (state) => state[nameSpace].totalCount;
/**
 * @param state
 * return {Number}
 */
export const page = (state) => state[nameSpace].page;
/**
 * @param state
 * return {Array}
 */
export const userList = (state) => state[nameSpace].userList;
/**
 * @param state
 * return {Array}
 */
export const autocompleteUserList = (state) => state[nameSpace].autocompleteUserList;

/**
 * @param state
 * return {Array}
 */
export const autocompleteSelectedUserList = (state) => state[nameSpace].autocompleteSelectedUserList;
